export const SYMPTOM_DETAILS = "https://api.infermedica.com/v3/parse";

export const DIAGNOSE = "https://api.infermedica.com/v3/diagnosis";

export const TRIAGE = "https://api.infermedica.com/v3/triage";